import { LoadingIndicator } from '../../components/loadingIndicator.tsx';

interface Props {
    style?: React.CSSProperties;
    isLoading: boolean;
    containerRef: React.RefObject<HTMLDivElement | null>;
}

export function ReportGraphContainer({
    isLoading,
    containerRef,
    style,
}: Props) {
    return (
        <div className='report-graph-container' style={style}>
            <div ref={containerRef} className='report-graph-container__graph' />
            {isLoading && <ReportGraphLoading />}
        </div>
    );
}

export function ReportGraphLoading() {
    return (
        <div className='report-graph-loading' role='status' aria-live='polite'>
            <LoadingIndicator title='Loading report' text='Preparing graph data...' />
        </div>
    );
}
